export const scrollToTopOfContent = () => {
  const content = document.querySelector('#templates-wrapper')
  content.scrollTop = 0
}
